import dispatcher from '../dispatcher';
import '../form/input-wrapper.component';

var elementProto = Object.create(HTMLLabelElement.prototype);

var _getData = function() {
	return {
		value: this.value,
	}
}

var _handleDrop = function(e) {
	var files = [];
	e.preventDefault();

	if (!e.dataTransfer) return;

	// if (e.dataTransfer.items) {
	// 	for (var i = 0; i < e.dataTransfer.items.length; i++) {
	// 		if (e.dataTransfer.items[i].kind === 'file') {
	// 			files.push(e.dataTransfer.items[i].getAsFile());
	// 		}
	// 	}
	// } else {
	// 	files = e.dataTransfer.files;
	// }

	this._input.files = e.dataTransfer.files;

	if (e.dataTransfer.items) {
		e.dataTransfer.items.clear();
	} else {
		e.dataTransfer.clear();
	}

	this.classList.remove('drag');
	this._input.focus();
}

var _handleOver = function(e) {
	e.preventDefault();

	if (!this.classList.contains('drag')) {
		this.classList.add('drag');
	}
}

var _handleOut = function() {
	this.classList.remove('drag');
}

var _handleChange = function() {
	var files = this._input.files;
	if (files && files.length) {
		this.classList.add('not-empty');
		this._text.innerHTML = files[0].name;
	} else {
		this.classList.remove('not-empty');
		this._text.innerHTML = '';
	}
}

var _remove = function(e) {
	var event = new Event('change');
	e.stopPropagation();
	e.preventDefault();

	this._input.type = '';
	this._input.type = 'file';
	this._input.dispatchEvent(event);
}

elementProto.createdCallback = function() {
	this.getData = _getData.bind(this);
	this.handleDrop = _handleDrop.bind(this);
	this.handleOver = _handleOver.bind(this);
	this.handleOut = _handleOut.bind(this);
	this.handleChange = _handleChange.bind(this);
	this.remove = _remove.bind(this);
}
elementProto.attachedCallback = function() {
	this._text = this.getElementsByClassName('file-data')[0];
	this._input = this.getElementsByTagName('input')[0];
	this._remove = this.getElementsByClassName('remove')[0];

	this._input.addEventListener('change', this.handleChange);

	this.addEventListener('drop', this.handleDrop);
	this.addEventListener('dragover', this.handleOver);
	this.addEventListener('mouseleave', this.handleOut);
	this._remove.addEventListener('click', this.remove);
}
elementProto.detachedCallback = function() {
}

document.registerElement('file-input', {
	prototype: elementProto,
	extends: 'label'
});